/**
 * Shared Recharts styling.
 *
 * Charts inherit the design tokens from `style.css`; the palette below is the
 * categorical scale used for multi-series and donut charts.
 */

import { formatCompact } from '@/features/reports/lib/format';

export const CHART_COLORS = [
    '#2E7D32',
    '#1E88E5',
    '#F59E0B',
    '#8E24AA',
    '#00897B',
    '#D32F2F',
    '#546E7A',
    '#4CAF50',
];

export const chartTooltipStyle = {
    backgroundColor: 'var(--card-bg)',
    border: '1px solid var(--card-border)',
    borderRadius: 'var(--radius-sm)',
    boxShadow: 'var(--shadow-md)',
    color: 'var(--text-primary)',
    fontFamily: 'var(--font)',
    fontSize: '0.8rem',
    direction: 'rtl',
};

export const chartAxisTick = {
    fill: 'var(--text-secondary)',
    fontSize: 11,
    fontFamily: 'var(--font)',
};

export const chartGridStroke = 'var(--gray-light)';

/**
 * RTL reading direction: the value axis sits on the right and the category
 * axis runs right-to-left, which is how Persian readers scan a chart.
 */
export const rtlXAxisProps = {
    reversed: true,
    tick: chartAxisTick,
    tickLine: false,
    axisLine: { stroke: chartGridStroke },
};

export const rtlYAxisProps = {
    orientation: 'right',
    tick: chartAxisTick,
    tickLine: false,
    axisLine: false,
    // Wide enough for compact Persian money ticks such as «۱۲٫۵ میلیارد».
    width: 88,
};

/** Compact Persian number for axis ticks: `15000000` -> `۱۵ میلیون`. */
export const tickFormatter = (value) => {
    const amount = Number(value);
    if (!Number.isFinite(amount)) return '';
    return formatCompact(amount);
};
